var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"danger","size":_vm.size,"loading":_vm.loadingSure,"disabled":_vm.disabled},on:{"click":_vm.submit}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.buttonTxt)}})])}
var staticRenderFns = []

export { render, staticRenderFns }